import { computed, MaybeRef, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticatedAnd } from '@/utils/query-utils'
import { ComponentType } from '@/configuration/component/component-types'

export const useRecommendationQuery = (recommendationId: MaybeRef<number>, componentType: MaybeRef<ComponentType | null>) => {
    return useQuery({
        queryKey: ['recommendation', recommendationId],
        queryFn: async ({ signal }) => {
            const type = toValue(componentType)

            if (!type) {
                return null
            }

            const {
                data: { result },
            } = await hcaClientFactory.recommendationsApi.getRecommendation(toValue(recommendationId), type, { signal })

            // TODO: Move this sorting into BE logic
            result?.comments?.sort((a, b) => {
                if (!a.date || !b.date) {
                    return 0
                }

                return new Date(b.date).getTime() - new Date(a.date).getTime()
            })

            return result
        },
        enabled: whenAuthenticatedAnd(computed(() => !!toValue(recommendationId))),
        staleTime: Infinity,
    })
}
